/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Cross from '../icons/Close';

import styles from '../../../styles/buttons/close.module.scss';

const propTypes = {
    className: PropTypes.string,
    IconComponent: PropTypes.node,
    iconClassName: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func.isRequired,
};

const defaultProps = {
    IconComponent: null,
    iconClassName: null,
    color: null,
    className: null,
};

const CloseButton = ({ IconComponent, className, iconClassName, color, onClick, ...props }) => (
    <button
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        type="button"
        onClick={onClick}
        {...props}
    >
        {IconComponent === null ? (
            <Cross className={iconClassName} color={color} />
        ) : (
            <IconComponent className={iconClassName} color={color} />
        )}
    </button>
);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;

export default CloseButton;
